import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';

import usePresenceToast from './hooks/usePresenceToast';
import { PRESENCE_TOAST_MESSAGE } from './PresenceToast.constants';
import { toastContainerStyles, toastItemStyles } from './PresenceToast.styles';
import ToastNotification from './ToastNotification';

const PresenceToast = () => {
  const { notifications } = usePresenceToast();

  if (!notifications.length) {
    return null;
  }

  return (
    <Box sx={toastContainerStyles}>
      {notifications.map(({ id, type, displayName, firstName, lastName, avatarUrl, userId }) => (
        <Box key={id} sx={toastItemStyles}>
          <ToastNotification
            avatarUrl={avatarUrl}
            displayName={displayName}
            firstName={firstName}
            lastName={lastName}
            userId={userId}
          />{' '}
          <Typography color="text.primary" component="span" variant="regular14">
            {PRESENCE_TOAST_MESSAGE[type]}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default memo(PresenceToast);
